import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/Select";
import type { MenuProvided } from "react-instantsearch-core";
import { connectMenu } from "react-instantsearch-dom";
import { FormattedMessage } from "react-intl";

const RealEstateFundAudienceMenu = connectMenu<MenuProvided>(({ refine, currentRefinement }) => {
  const options = [
    { value: "Todos", label: <FormattedMessage defaultMessage="Todos" id="P8VfZA" /> },
    {
      value: "Investidor Profissional",
      label: <FormattedMessage defaultMessage="Investidor Profissional" id="Ew/GX+" />,
    },
    {
      value: "Investidor Qualificado",
      label: <FormattedMessage defaultMessage="Investidor Qualificado" id="Wi7hUc" />,
    },
    {
      value: "Investidor Qualificado e Profissional",
      label: <FormattedMessage defaultMessage="Investidor Qualificado e Profissional" id="crNbgy" />,
    },
    {
      value: "Investidores em Geral",
      label: <FormattedMessage defaultMessage="Investidores em Geral" id="or0mzL" />,
    },
  ];

  const selectValue = currentRefinement || "Todos";
  const selectedOption = options.find((opt) => opt.value === selectValue);

  return (
    <div className="space-y-4">
      <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">
        <FormattedMessage defaultMessage="Publico-alvo" id="eU0V4m" />
      </h3>

      <Select
        value={selectValue}
        onValueChange={(value) => {
          refine(value === "Todos" ? "" : value);
        }}
      >
        <SelectTrigger>
          <SelectValue placeholder={<FormattedMessage defaultMessage="Todos" id="P8VfZA" />}>
            {selectedOption?.label}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
});

export default function RealEstateFundAudience() {
  return <RealEstateFundAudienceMenu attribute="audience" />;
}
